type Props = {
  width: number;
  height: number;
  bends: number;
  start: number;
  end: number;
  spread?: number;
  shore?: "top" | "bottom";
};

export function Water({ width, height, bends, start, end, spread, shore = "bottom" }: Props) {
  spread = spread ?? height / 10; // oxlint-disable-line no-param-reassign, logical-assignment-operators -- blocked by react(todo)
  let d = `M0 ${start}`;
  const sepX = width / (bends + 1);
  const sepY = (end - start) / (bends + 1);
  let x = 0;
  let y = start;
  let dy = 0;
  for (let i = 0; i < bends; i += 1) {
    d += ` C${x + sepX / 3} ${y + dy}`;
    x += sepX;
    y += sepY;
    dy = (i & 1 ? -1 : 1) * spread;
    d += ` ${x - sepX / 3} ${y + dy} ${x} ${y + dy}`;
  }
  d += ` C${x + sepX / 3} ${y + dy}`;
  x += sepX;
  y += sepY;
  d += ` ${x - sepX / 3} ${y} ${x} ${y}`;
  d += shore === "top" ? `L${width} ${height} L0 ${height} Z` : `L${width} 0 L0 0 Z`;
  return (
    <div className="relative size-full">
      <svg
        viewBox={`0 0 ${width} ${height}`}
        className="absolute inset-0 fill-water"
        preserveAspectRatio="none"
        width="100%"
        height="100%"
      >
        <path d={d} />
      </svg>
    </div>
  );
}
